module.exports = __webpack_public_path__ + "static/media/create-site-and-agent-step-2-br.00fa5049.png";